import { Box, BoxProps, VStack } from "@chakra-ui/react"
import { SupportedTokenName } from "@mezo/sdk"

import { PortalToken } from "#/shared/types"

import TokenSelectButton from "./TokenSelectButton"

type DepositTokenSelectDropdownProps = BoxProps & {
  tokens: PortalToken<SupportedTokenName>[]
  selectedToken?: PortalToken<SupportedTokenName>
  updateSelectedToken: (token: PortalToken<SupportedTokenName>) => void
  isDropdownOpen: boolean
  withTokenBalance?: boolean
}

export default function TokenSelectDropdown({
  selectedToken,
  tokens,
  updateSelectedToken,
  isDropdownOpen,
  withTokenBalance = false,
  ...props
}: DepositTokenSelectDropdownProps) {
  if (!isDropdownOpen) return null

  return (
    <Box
      p={2}
      bg="primary.white.100"
      pos="absolute"
      right={0}
      top="72px"
      zIndex={11}
      rounded="8px"
      boxShadow="0px 4px 17px 0px rgba(0, 0, 0, 0.15)"
      {...props}
    >
      <VStack
        w="auto"
        maxH="226px"
        overflowY="scroll"
        gap="2px"
        alignItems="flex-start"
        css={{
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(0, 0, 0, 0.05)",
            borderRadius: "40px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(0, 0, 0, 0.3)",
            borderRadius: "40px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        {tokens.map(({ token, icon, invertColorOnHover }) => (
          <TokenSelectButton
            key={token}
            token={token}
            icon={icon}
            invertColorOnHover={invertColorOnHover}
            onChange={() => {
              updateSelectedToken({ token, icon })
            }}
            isCurrentToken={selectedToken?.token === token}
            withTokenBalance={withTokenBalance}
          />
        ))}
      </VStack>
    </Box>
  )
}
